module.exports = __webpack_public_path__ + "img/ministerio.a76f7cdb.png";